export const getFeedTypeColor = (feedType) => {
  switch (feedType) {
    case "Schedule":
      return "warning";
    case "Squad":
      return "secondary";
    case "MatchStats":
      return "warning";
    default:
      return "default";
  }
};

export const getStatusColor = (status) => {
  switch (status) {
    case "Success":
      return "success";
    case "Failed":
      return "error";
    default:
      return "default";
  }
};

export const formatDate = (dateString) => {
  return new Date(dateString).toLocaleString("en-US", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    timeZone: "America/New_York",
  });
};
